export default __webpack_public_path__ + "static/blog-details-fb50e94f7547cede1bcc161297b3d313.jpg";